import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
    selector: 'app-share-this-view',
    templateUrl: './share-this-view.component.html',
    styles: [],
    standalone: false
})
export class ShareThisViewComponent {
  @Input() alwaysHideLabel = false;
  @Input() label = 'Share This View';
  @Input() disabled = false;
  @Input() disabledTooltip = 'Sharing is not available right now';
  @Output() shareClick = new EventEmitter<void>();
  constructor() {}

  onShareClick(): void {
    this.shareClick.emit();
  }
}
